import React, { useMemo, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Table } from "reactstrap";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { convertPayment, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraDutyPaymentClaimApprovalList, resetAll } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import CustomMonthPicker from "common/CustomMonthPicker";
import { FaCheck } from "react-icons/fa";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const PaymentApproval = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [authDetails, setAuthDetails] = useState(null);
    const dispatch = useDispatch()

    // const { categories } = useSelector((state) => state.CategoryMaster || {});
    // const { departments } = useSelector((state) => state.DepartmentMaster || {});
    // const { designations } = useSelector((state) => state.DesignationMaster || {});

    const {
        approvalList,
        dropdownAutoList,
        categories,
        departments,
        designations,
        loading,
        success,
        error,
        } = useSelector((state) => ({
        categories: state.CategoryMaster?.categories ?? [],
        departments: state.DepartmentMaster?.departments ?? [],
        designations: state.DesignationMaster?.designations ?? [],
        dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
        approvalList: state.AttendanceExtraDutyReducer?.approvalList ?? [],

        loading: state.AttendanceExtraDutyReducer?.loading,
        error: state.AttendanceExtraDutyReducer?.error,
        success: state.AttendanceExtraDutyReducer?.success,
    }));
    const [timesheetApprovalData, setTimesheetApprovalData] = useState();


    useEffect(() => {
        if (approvalList && approvalList.length > 0) {          
            const initializedData = (approvalList || []).map(row => ({
            ...row,
                selectedOption: "Discussion",
                worked_hours:row.approved_hour,
            }));
            setTimesheetApprovalData(initializedData)
        }else{
            setTimesheetApprovalData([])
        }
    }, [approvalList])

     useEffect(() => {
        if (success) {
            handleCancel();
        }
    }, [authDetails,success,dispatch]);

    useEffect(() => {
        dispatch(resetAll());
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchDepartments(unitId));
        dispatch(fetchCategories(unitId));
        dispatch(fetchDesignations(unitId));
        dispatch(fetchEmployeeDropdownAutoList(unitId));
    }, [dispatch]);


    // Formik Setup
    const formik = useFormik({
        initialValues: {
            category: [],        
            department: [],      
            designation: [],     
            employee: null,      
            fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),        
        },
        validationSchema: Yup.object({                
            fromDate: Yup.string().nullable()
                .required("Month is required"),
        }),
        onSubmit: (values) => {
            console.log("Payment Approval Data:", values);

            const formData = new FormData();
            formData.append("emp_id", values.employee?.value || "");         
            formData.append("sal_month", values.fromDate || "");                 
            formData.append("dept_id", values.department?.join(",") || "");  
            formData.append("cat_id", values.category?.join(",") || "");     
            formData.append("desig_id", values.designation?.join(",") || "");     
            formData.append("unit_id", authDetails?.unit_id || "");
            formData.append("create_by", authDetails?.user_id || "");
            dispatch(fetchExtraDutyPaymentClaimApprovalList(formData))
        },
    });

    const handleOptionChange = (rowId, action) => {
        // // Update the selected option for the specific row
        const updatedData = timesheetApprovalData.map((row) => {
          if (row.extra_hours_paymentid === rowId) {
            return { ...row, selectedOption: action };
          }
          return row;
        });

        setTimesheetApprovalData(updatedData);
    };

    const handleBulkActionChange = (action) => {
        const updatedData = timesheetApprovalData.map((row) => ({
        ...row,
        selectedOption: action,
        }));
        setTimesheetApprovalData(updatedData);
    };
    
    const handleRemarksChange = (sno, value) => {
        const updatedData = (timesheetApprovalData || []).map((item) =>
        item.extra_hours_paymentid === sno ? { ...item, remarks: value } : item
        );
        setTimesheetApprovalData(updatedData);
    };
    
    const formatTimeWithColon = (val) => {
        const digits = val.replace(/\D/g, "").slice(0, 4);
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}:${digits.slice(2)}`;
    };
    
    const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    };
    
    const handleHourChange = (value, rowIndex) => {
        let input = value.trim();
    
        // Handle input without colon
        if (!input.includes(":")) {
        const digitsOnly = input.replace(/\D/g, "");
        if (digitsOnly.length === 1) {
            input = `0${digitsOnly}:00`; // "3" → "03:00"
        } else if (digitsOnly.length === 2) {
            input = `${digitsOnly}:00`; // "12" → "12:00"
        }
        }
    
        const formatted = formatTimeWithColon(input); // Force to HH:MM
        const updated = [...timesheetApprovalData];
    
        const approvedMinutes = timeToMinutes(formatted);
        const workedMinutes = timeToMinutes(updated[rowIndex]?.worked_hours || "00:00");
    
        if (approvedMinutes > workedMinutes) {
        Swal.fire({
            icon: 'warning',
            title: 'Invalid Entry',
            text: 'Approved hours cannot be greater than worked hours.',
        });
        updated[rowIndex].approved_hour = updated[rowIndex].worked_hours;
        } else {
        updated[rowIndex].approved_hour = formatted;
        }
    
        setTimesheetApprovalData(updated); // Ensure update reflects globally
    };


    const columns = [
      { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index, className: "serial-no", applyHeaderClass: true, },
      { Header: "Code", accessor: "emp_no" },
      { Header: "Name", accessor: "emp_name" },
      { Header: "Category", accessor: "emp_category" },
      { Header: "Department", accessor: "department" },
      { Header: "Month", accessor: "salary_month" },
      { Header: "Available Hrs", accessor: "available_hour" },
      {
        Header: "ApprovedHrs",
        accessor: "approved_hour",
        Cell: ({ row }) => {
            const rowIndex = row.index;
            const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.approved_hour || "");
            // const value = timesheetApprovalData[rowIndex]?.approved_hour || "";
    
            return (
            <Input
                type="text"
                value={value}
                onChange={(e) => setValue(formatTimeWithColon(e.target.value))}
                // onBlur={(e) => handleHourChange(e.target.value, rowIndex)} // ensures sync on blur too
                onBlur={(e) => {
                const formatted = formatTimeWithColon(e.target.value);
                setValue(formatted); // update local state
                handleHourChange(formatted, rowIndex); // validate and save to global state
                }}
                placeholder="HH:MM"
                style={{ width: "80px", padding: "4px" }}
            />
            );
        },
    },
    {
        Header: "Remarks",
        Cell: ({ row }) => {
            const rowIndex = row.index;
            const [value, setValue] = useState(timesheetApprovalData[rowIndex]?.remarks || "");
    
            const handleBlur = () => {
            if (value) {
                handleRemarksChange(row.original.extra_hours_paymentid, value);
            }
            };
    
            return (
            <Input
                type="text"
                bsSize="sm"
                placeholder="Enter remarks"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onBlur={handleBlur} // only update global state on focus out
            />
            );
        }
    },
      {
        id: "approve",
        Header: () => (
          <div className="text-center">
            Approve <br />
            <Input
              type="radio"
              name="selectAll"
              onChange={() => handleBulkActionChange("Approve")}
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => handleOptionChange(row.original.extra_hours_paymentid, "Approve")}
            style={{ cursor: "pointer" }}
          >
            {row.original.selectedOption === "Approve" ? (
              <FaCheck color="green" size={20} />
            ) : (
              <Input
                type="radio"
                name={`action-${row.original.extra_hours_paymentid}`}
                onChange={() => handleOptionChange(row.original.extra_hours_paymentid, "Approve")}
                checked={row.original.selectedOption === "Approve"}
              />
            )}
          </div>
        ),
      },
      {
        id: "reject",
        Header: () => (
          <div className="text-center">
            Reject <br />
            <Input
              type="radio"
              name="selectAll"
              onChange={() => handleBulkActionChange("Reject")}
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => handleOptionChange(row.original.extra_hours_paymentid, "Reject")}
            style={{ cursor: "pointer" }}
          >
            {row.original.selectedOption === "Reject" ? (
              <FaCheck color="red" size={20} />
            ) : (
              <Input
                type="radio"
                name={`action-${row.original.extra_hours_paymentid}`}
                onChange={() => handleOptionChange(row.original.extra_hours_paymentid, "Reject")}
                checked={row.original.selectedOption === "Reject"}
              />
            )}
          </div>
        ),
      },
      {
          id: "discussion",
          Header: () => (
          <div className="text-center">
            None <br />
            <Input
              type="radio"
              name="selectAll"
              onChange={() => handleBulkActionChange("Discussion")}
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => handleOptionChange(row.original.extra_hours_paymentid, "Discussion")}
            style={{ cursor: "pointer" }}
          >
            {row.original.selectedOption === "Discussion" ? (
              <FaCheck color="orange" size={20} />
            ) : (
              <Input
                type="radio"
                name={`action-${row.original.extra_hours_paymentid}`}
                onChange={() => handleOptionChange(row.original.extra_hours_paymentid, "Discussion")}
                checked={row.original.selectedOption === "Discussion"}
              />
            )}
          </div>
        ),
      },
    ];

    const handleLateApprove = () => {
        const updatedApprovals = (timesheetApprovalData || [])
            .filter(item => item.selectedOption !== "Discussion")
            .map(item => ({
            extra_hours_paymentid: item.extra_hours_paymentid || 0, 
            emp_id: item.emp_id?.toString() || "",
            month: item.api_salary_month,
            balance_mins: item.balance_mins?.toString() || "0",
            apphrs: item.approved_hour || "00:00",
            remarks: item.remarks || "", 
            app_status: item.selectedOption === "Approve" ? 2 : (item.selectedOption === "Reject" ? 3 : 0),
            }));

        if (updatedApprovals.length === 0) {
            Swal.fire({
            icon: "warning",
            title: "No Selection",
            text: "Please select at least one before proceeding.",
            });
            return;
        }

         const missingRemarks = updatedApprovals.filter(
            item => item.app_status === 3 && !item.remarks.trim()
        );

        if (missingRemarks.length > 0) {
            Swal.fire({
            icon: "warning",
            title: "Remarks Required",
            text: "Please enter remarks for all rejected employees before submitting.",
            });
            return;
        }

        // ✅ Final payload structure
        const payload = { payment: updatedApprovals };
        const convertObject = JSON.stringify(payload);

        // ✅ FormData build
        const formData = new FormData();
        formData.append("lst_employee_ConvertPayment", convertObject);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("create_by", authDetails?.user_id);

        // ✅ Dispatch saga action
        dispatch(convertPayment(formData));
    };


    const handleCancel = () => {
        setTimesheetApprovalData([])
        formik.resetForm()
    }


    return (

        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Extra Duty" breadcrumbItem="Payment Approval" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <form onSubmit={formik.handleSubmit}>
                                        <Row >
                                            {/* Category */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Category</Label>
                                                    <CustomSelect
                                                        id="category"
                                                        name="category"
                                                        options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                                                        value={
                                                            categories
                                                                .filter(cat => formik.values.category?.includes(cat.empCatgryid))
                                                                .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                                                        }
                                                        onChange={val => formik.setFieldValue('category', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                                                    />
                                                    {formik.errors.category && formik.touched.category && (
                                                        <div className="text-danger">{formik.errors.category}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* Department */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Department</Label>
                                                    <CustomSelect
                                                        id="department"
                                                        name="department"
                                                        options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                                                        value={
                                                            departments
                                                                .filter(dept => formik.values.department?.includes(dept.departmentId))
                                                                .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                                                        }
                                                        onChange={val => formik.setFieldValue('department', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}

                                                    />
                                                    {formik.errors.department && formik.touched.department && (
                                                        <div className="text-danger">{formik.errors.department}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>


                                            {/* Designation */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Designation</Label>
                                                    <CustomSelect
                                                        id="designation"
                                                        name="designation"
                                                        options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                                                        value={
                                                            designations
                                                                .filter(desig => formik.values.designation?.includes(desig.desig_id))
                                                                .map(desig => ({ value: desig.desig_id, label: desig.designation }))
                                                        }
                                                        onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}

                                                    />
                                                    {formik.errors.designation && formik.touched.designation && (
                                                        <div className="text-danger">{formik.errors.designation}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                <Label for="employee">Employee</Label>
                                                <CustomSelect
                                                    id="employee"
                                                    name="employee"
                                                    options={(dropdownAutoList || []).map(emp => ({ value: emp.emp_id.toString(), label: emp.emp_no }))}
                                                    value={formik.values.employee || null}
                                                    onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                                                />
                                                {formik.touched.employee && formik.errors.employee && (
                                                    <div className="text-danger">{formik.errors.employee}</div>
                                                )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3} className="mb-3">
                                                <FormGroup>
                                                <Label for="fromDate">Month <span className="text-danger">*</span></Label>
                                                <CustomMonthPicker
                                                    name="fromDate"
                                                    value={formik.values.fromDate}
                                                    onChange={(date) => formik.setFieldValue("fromDate", date)}
                                                    onBlur={formik.handleBlur}
                                                    disableFuture={true}
                                                    className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                                                />
                                                {formik.touched.fromDate && formik.errors.fromDate && (
                                                    <div className="text-danger">{formik.errors.fromDate}</div>
                                                )}
                                                </FormGroup>
                                            </Col>

                                            {/* Buttons */}
                                            <Col className="d-flex align-items-center justify-content-end mob-center">
                                                <Button type="submit" className="btn button-search me-2">
                                                    <i className="fas fa-search me-1" /> Search
                                                </Button>
                                                <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                                {canApprove && timesheetApprovalData && timesheetApprovalData.length > 0 ? (
                                                    <Button type="button" className="btn button-save" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleLateApprove();
                                                                }}>
                                                        <i className="fas fa-paper-plane me-1" /> Submit
                                                    </Button>
                                                ):''}
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <TableContainer
                                        columns={columns}
                                        data={timesheetApprovalData && timesheetApprovalData.length > 0 ? timesheetApprovalData : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>


    );
};

export default PaymentApproval;
